import { render, staticRenderFns } from "./EstablishmentEditTabInformation.vue?vue&type=template&id=53d79560&"
import script from "./EstablishmentEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./EstablishmentEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports